import { render, staticRenderFns } from "./ConfigCategoryGeneral.vue?vue&type=template&id=3b97fd87&"
import script from "./ConfigCategoryGeneral.vue?vue&type=script&lang=js&"
export * from "./ConfigCategoryGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports